import * as React from "react";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

type NavigateIcon = SvgIconProps;

function NavigateIcon({ ...others }: NavigateIcon) {
  return (
    <SvgIcon {...others}>
      <NavigateNextIcon />
      <NavigateNextIcon viewBox="6 0 24 24" />
    </SvgIcon>
  );
}

export default NavigateIcon;
